export default __webpack_public_path__ + "static/media/piotr.88398dc7.jpg";